
/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ScaffoldCombinedData {
  SiteDepotId: string;
  SiteDepotName: string;
  CustomerId: string;
  CustomerName: string;
  ContractId: string;
  ContractName: string;
  ContractNumber: string;
  SiteId: string;
  SiteName: string;
  SiteNumber: string;
  ScaffoldId: string;
  ScaffoldName: string;
  ScaffoldStatus: string;
  ScaffoldingSystemName: string;
  ScaffoldingSystemId: string;
  SiteAddress: string;
  ScaffoldNumber: string;
  QuoteNumber: string;
  ItemNumber: string;
  ScaffoldingSystemNotSet: boolean;
  IsScaffoldSystemDeleted: boolean;
  HandedOverTonnage: number;
  AllocatedTonnage: number;
  MaximumTonnage: number;
  StandingTonnage: number;
}


